import { Button, Grid, Stack } from "@mui/material";
import React from "react";
import { PaymentModal } from "./paymentModal";
export const PaymentPage = () => {
  const [open, setOpen] = React.useState(false);
  const PaymentType = {
    UtilityPayment: "UtilityPayment",
    StaffPayment: "StaffPayment",
    Other: "Other",
    SupplierPayment: "SupplierPayment",
  };
  const [type, setType] = React.useState(PaymentType.UtilityPayment);
  return (
    <Stack>
      <Grid
        container
        spacing={24}
        justify="center"
        style={{ minHeight: "100vh", maxWidth: "100%" }}
      >
        <Grid container item xs={12} spacing={8}>
          <Grid item xs={6}>
           
          </Grid>
          <Grid item xs={6}>
          <Button
              variant="contained"
              color="primary"
              style={{ marginTop: "2rem" }}
              onClick={() => {
                setType(PaymentType.StaffPayment);
                setOpen(true);
              }}
            >
               Payment
            </Button>
          </Grid>
          <Grid item xs={6}>
         
          </Grid>
          <Grid item xs={6}>
         
          </Grid>
        </Grid>
      </Grid>
      <PaymentModal open={open} onClose={() => setOpen(false)} type={type} />
    </Stack>
  );
};
